import { isPersistableQueryKey } from '@/config/persisted-query-params/constants';

const buildRestorableParams = (
  snapshot: Record<string, string>,
  base: URLSearchParams
): { next: URLSearchParams; hasRestorableParams: boolean } => {
  const next = new URLSearchParams(base);
  let hasRestorableParams = false;
  for (const [k, v] of Object.entries(snapshot)) {
    if (isPersistableQueryKey(k)) {
      next.set(k, v);
      hasRestorableParams = true;
    }
  }
  return { next, hasRestorableParams };
};

export default buildRestorableParams;
